import NextLink from 'next/link';
import PropTypes from 'prop-types';

import Button from 'shopper/components/Button';

import { sendEvent } from 'lib/gtag';
import placeholder from 'lib/placeholder';

import CommentsButton from './CommentsButton';

import LINKS from 'constants/links';

const onRecentThreadsClick = (gaEventCategory) =>
  sendEvent({ action: 'topbar_forum', category: gaEventCategory });

const ForumNavigation = ({ gaEventCategory }) => (
  <>
    <NextLink href={LINKS.FORUM} prefetch={false} passHref>
      <Button
        as="a"
        className="mr-2"
        data-test-selector="recent-topics-tab"
        size="size4"
        type="neutral-ghost"
        onClick={() => onRecentThreadsClick(gaEventCategory)}
      >
        {placeholder('actions.seeLastThreads')}
      </Button>
    </NextLink>
    <CommentsButton />
  </>
);

ForumNavigation.propTypes = {
  gaEventCategory: PropTypes.string.isRequired,
};

export default ForumNavigation;
